import React from "react";
const helpcanvas = {
  display: 'grid',
  gridTemplateColumns: '2fr 3fr 5fr',
  gridTemplateRows: 'min-content 1fr',
  backgroundColor: "#f2f2f2",
  height: '100vh',
  width: '100%',
  rowGap: '24px',
  columnGap: '14px',
  padding: '0 0 14px 0',
};

const helptitle = {
  color: "#222",
  backgroundColor: "#f2f2f2",
  padding: "2px",
  fontFamily: "Arial",
  fontSize: "13px",
};

const helpimg = {
    color: "#222",
    backgroundColor: "#f2f2f2",
    padding: "2px",
    fontFamily: "Arial",
  };

const UIDSDash = {
    name: 'DS Dashboard Grade',
    imageUrl: './images/UI_DS_Dash.png',
    imageSize: "100%",
    bradius: 20,
  };

const UIDSRiskgrade = {
    name: 'DS Risk Grade',
    imageUrl: '../../images/DSRiskgrade.png',
    imageSize: "60%",
    bradius: 20,
  };

const UIDSTrendChart = {
    name: 'DS Risk Trend Chart',
    imageUrl: '../../images/DSTrendChart.png',
    imageSize: "90%",
    bradius: 20,
  };

const UIDSTrendfilter = {
    name: 'DS Risk Trend Filter',
    imageUrl: '../../images/DSTrendfilter.png',
    imageSize: "70%",
    bradius: 20,
  };

const UIDSTop5 = {
    name: 'DS Top 5 Chart',
    imageUrl: '../../images/DSTop5.png',
    imageSize: "50%",
    bradius: 20,
  };

const UIDSTop10 = {
    name: 'DS Top 10 Table',
    imageUrl: '../../images/DSTop10.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDSCatAnalysis = {
    name: 'DS Top 10 Table',
    imageUrl: '../../images/DSCatAnalysis.png',
    imageSize: "99%",
    bradius: 20,
  };

const UIDSActivescans = {
    name: 'DS Active Scans',
    imageUrl: '../../images/DSActivescans.png',
    imageSize: "65%",
    bradius: 20,
  };

const UIDSLast5 = {
    name: 'DS Top 5 Scans',
    imageUrl: '../../images/DSLast5.png',
    imageSize: "65%",
    bradius: 20,
  };

const UIDSScheduledscans = {
    name: 'DS Scheduled Scans',
    imageUrl: '../../images/DSScheduledscans.png',
    imageSize: "65%",
    bradius: 20,
  };

const UIDSMitprogress = {
    name: 'DS Mitigation Progress',
    imageUrl: '../../images/DSMitprogress.png',
    imageSize: "65%",
    bradius: 20,
  };



export const DSDash = () => {
  return (
    <div style={helpcanvas}>
      <div
      style={{ marginLeft: "310px" }}
      ></div>
      <div style={helptitle}><b>Data Scan Dashboard</b><br/><br/>
      The Data Scan dashboard gives you an overview of how your previous or current data scans have performed or are 
      performing. Through this, determine how vulnerable your instance is based on the sensitivity of the data found 
      in the organization’s systems. <br/><br/>
      Data with higher sensitivity increases your exposure since the loss or theft of sensitive data is more damaging 
      to an organization. 

      </div>
      <div style={helpimg}>
      <img
        src={UIDSDash.imageUrl}
        alt={'Image of ' + UIDSDash.name}
        style={{
          width: UIDSDash.imageSize,
          borderRadius: UIDSDash.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const DSRiskGrade = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Datascan Risk Grade</b><br /><br />
      The Data Scan Risk Grade is based on the ratio of sensitive vs. non-sensitive data discovered plus a severity rating based on 
      the risk value of the sensitive data. The main grade shown under Data Scan Risk Grade is for the current reporting period 
      (Month or Quarter), and the grade shown just below that in a smaller font size is for the previous reporting period. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDSRiskgrade.imageUrl}
        alt={'Image of ' + UIDSRiskgrade.name}
        style={{
          width: UIDSRiskgrade.imageSize,
          borderRadius: UIDSRiskgrade.bradius,
        }}
      />
      </div>
    </div>
  );
};
 
export const DSTrendChart = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Data Scan Trend</b><br /><br />
      The Data Scan Trend Chart shows you the history of scanning efforts for your instance over various time periods. Data scan 
      trends for your instance are shown by the risk grade based on the number and sensitivity levels of the sensitive files 
      found during the selected reporting period. (See the options at the top right of the chart.)  <br /><br />
      <br /><br /><br /><br />
      Track your organization’s progress on data sensitivity reduction over your selected period. Select a Week, Month, 
      Quarter or Year as your current reporting period from the options at the top right as shown here.<br /><br />
      <img
        src={UIDSTrendfilter.imageUrl}
        alt={'Image of ' + UIDSTrendfilter.name}
        style={{
          width: UIDSTrendfilter.imageSize,
          borderRadius: UIDSTrendfilter.bradius,
        }}
      /><br /><br />
      We highly recommend you continue to monitor your data sensitivity reduction through the dashboard.
      </div>
      <div style={helpimg}>
      <img
        src={UIDSTrendChart.imageUrl}
        alt={'Image of ' + UIDSTrendChart.name}
        style={{
          width: UIDSTrendChart.imageSize,
          borderRadius: UIDSTrendChart.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSTop5 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Top 5 Categories Searched</b><br /><br />
      The <b>Top 5 Categories Searched</b> display simply highlights what top categories you have searched for when performing 
      data scans on your instance during this scan reporting period.
      </div>
      <div style={helpimg}>
      <img
        src={UIDSTop5.imageUrl}
        alt={'Image of ' + UIDSTop5.name}
        style={{
          width: UIDSTop5.imageSize,
          borderRadius: UIDSTop5.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSTop10 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Top 10 Targets with Most Sensitive Data</b><br /><br />
      This display not only illustrates the top 10 targets with the most sensitive data but also gives an overview as to when 
      the last data scan was performed on that particular target, how many completed scans have been performed, the sum of the 
      sensitive items identified during all the scans performed during the current reporting period, a percentage of sensitive 
      items being discovered versus overall discovered items, along with the overall target risk grade. 
      </div>
      <div style={helpimg}>
      <img
        src={UIDSTop10.imageUrl}
        alt={'Image of ' + UIDSTop10.name}
        style={{
          width: UIDSTop10.imageSize,
          borderRadius: UIDSTop10.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSDatacat = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Data Category Analysis</b><br /><br />
      The Data Category Analysis graph provides an overview of what types of sensitive data you are scanning for and discovering 
      for your instance.<br/><br/>
      Through this graphical view, use the view-by-month slider which allows you to see month-over-month the overall breakdown 
      of what sensitive data was actually discovered.  <br/><br/>
      You can also use this bar chart to act as a filter. See exactly what items were found under a particular category and for 
      the month selected, which will then be displayed within the items found table located to the right of the graphical display. 
      <br/><br/>For example, if you select Addresses, you will see all the Addresses in the month of April as per the selection 
      of the view by month slider at the top. The filtered list shows the item names, the dates when the addresses were discovered, 
      and their actual location as shown here.  

      </div>
      <div style={helpimg}>
      <img
        src={UIDSCatAnalysis.imageUrl}
        alt={'Image of ' + UIDSCatAnalysis.name}
        style={{
          width: UIDSCatAnalysis.imageSize,
          borderRadius: UIDSCatAnalysis.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSActivescans = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Active Data Scans</b><br /><br />
      This shows any active data scans that you are currently running for your instance. Click on View All to see the complete list.  

      </div>
      <div style={helpimg}>
      <img
        src={UIDSActivescans.imageUrl}
        alt={'Image of ' + UIDSActivescans.name}
        style={{
          width: UIDSActivescans.imageSize,
          borderRadius: UIDSActivescans.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSLast5 = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Last 5 Data Scans</b><br /><br />
      This shows you the last 5 data scans that have been performed on your instance.  

      </div>
      <div style={helpimg}>
      <img
        src={UIDSLast5.imageUrl}
        alt={'Image of ' + UIDSLast5.name}
        style={{
          width: UIDSLast5.imageSize,
          borderRadius: UIDSLast5.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSScheduledscans = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Scheduled Scans</b><br /><br />
      See any scheduled data scans (both one-time and recurring) for your instance here. The information 
      shown includes scan names, whether they are set to one-time or recurring, the next scan date and the 
      number of targets to be covered by each scan.  

      </div>
      <div style={helpimg}>
      <img
        src={UIDSScheduledscans.imageUrl}
        alt={'Image of ' + UIDSScheduledscans.name}
        style={{
          width: UIDSScheduledscans.imageSize,
          borderRadius: UIDSScheduledscans.bradius,
        }}
      />
      </div>
    </div>
  );
};

export const DSMitprogress = () => {
  return (
    <div style={helpcanvas}>
      <div style={{ marginLeft: "310px" }}></div>
      <div style={helptitle}><b>Mitigation Plans in Progress</b><br /><br />
      This is an overview of the mitigation plans in the Data Scan category that are currently in progress for your instance. 

      </div>
      <div style={helpimg}>
      <img
        src={UIDSMitprogress.imageUrl}
        alt={'Image of ' + UIDSMitprogress.name}
        style={{
          width: UIDSMitprogress.imageSize,
          borderRadius: UIDSMitprogress.bradius,
        }}
      />
      </div>
    </div>
  );
};



